import React from 'react';
import ReactDOM from 'react-dom';
import { toastr } from 'react-redux-toastr';
import { Popup, Icon, Image } from "semantic-ui-react";
import { dispatch } from "@rematch/core";
import diamond from '../../../../../../images/grafix-icon/diamond.svg'
import EllipsisTooltip from './../../../../../common/EllipsisTooltip'
import completeActivity from "../../../../../../images/grafix-icon/completeActivity.svg";
var moment = require('moment');
function selectInputText(element) {
    element.setSelectionRange(0, element.value.length);
}

export default class InlineEdit extends React.Component {

    static defaultProps = {
        minLength: 1,
        maxLength: 128,
        editingElement: 'input',
        staticElement: 'span',
        tabIndex: 0,
        isDisabled: false,
        editing: false
    };

    state = {
        editing: this.props.editing,
        text: this.props.text,
        colorTag: this.props.colorTag,
        minLength: this.props.minLength,
        maxLength: this.props.maxLength,
        error: false,
    };

    componentWillMount() {
        this.isInputValid = this.props.validate || this.isInputValid;
        // Warn about deprecated elements
        if (this.props.element) {
            //console.warn('`element` prop is deprecated: instead pass editingElement or staticElement to InlineEdit component');
        }
    }

    componentWillReceiveProps(nextProps) {
        const isTextChanged = (nextProps.text !== this.props.text);
        const isColorChanged = (nextProps.colorTag !== this.props.colorTag);
        const isEditingChanged = (nextProps.editing !== this.props.editing);
        let nextState = {};
        if (isTextChanged) {
            nextState.text = nextProps.text;
        }
        if (isColorChanged) {
            nextState.colorTag = nextProps.colorTag;
        }
        if (isEditingChanged) {
            nextState.editing = nextProps.editing;
        }
        if (isTextChanged || isEditingChanged || isColorChanged) {
            this.setState(nextState);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let inputElem = ReactDOM.findDOMNode(this.refs.input);
        if (this.state.editing && !prevState.editing) {
            inputElem.focus();
            selectInputText(inputElem);
        } else if (this.state.editing && prevProps.text !== this.props.text) {
            this.finishEditing();
        }
    }

    startEditing = (e) => {
        if (this.props.stopPropagation) {
            e.stopPropagation()
        }
        this.setState({ editing: true, text: this.props.text });
    };

    finishEditing = () => {
        let elementType;
        if (this.props.elementType === 'communities') {
            elementType = 'Community';
        }
        else if (this.props.elementType === 'activities') {
            elementType = 'Activity';
        }
        if (this.isInputValid(this.state.text) && this.props.text !== this.state.text) {
            if (/^[^-\s][\s\S]{0,127}$/.test(this.state.text)) {
                this.commitEditing();
                // toastr.success('Message', elementType + ' updated successfully.')
            }
            else {
                toastr.error('Message', 'Invalid ' + elementType + ' name.')
                this.cancelEditing();
            }
        } else if (this.props.text === this.state.text || !this.isInputValid(this.state.text)) {
            this.cancelEditing();

        }
        this.props.setEditModeFalse();
    };

    cancelEditing = () => {
        this.setState({ editing: false, text: this.props.text });
    };

    commitEditing = () => {
        this.setState({ editing: false, text: this.state.text });
        let newProp = {};
        newProp[this.props.paramName] = this.state.text;
        this.props.change(newProp, this.props.data);
    };

    doubleClickOnActivity = (e) => {

        if (this.props.activityRow._id) {
            dispatch.initiatives.showResourecePane("ConfigureActivities");
            dispatch.initiatives.splitAt("60%");
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            let payload = {}
            payload.practiceId = this.props.practiceId;
            payload.activityid = this.props.activityRow._id;
            this.props.getSelection(this.props.activityRow._id);
        }
        else {
            dispatch.initiatives.showResourecePane(null);
        }
    };

    isInputValid = (text) => {
        if (text.length > this.state.maxLength)
            toastr.error('Message', 'Maximum 128 characters allowed.')
        return (text.length >= this.state.minLength && text.length <= this.state.maxLength && this.props.validationFunction(text, this.props.data.id));
    };

    keyDown = (event) => {
        event.stopPropagation();
        if (event.keyCode === 13) {
            this.finishEditing();
        } else if (event.keyCode === 27) {
            this.cancelEditing();
        }

    };

    textChanged = (event) => {
        this.setState({
            text: event.target.value.trim()
        });
    };
    updateActivityData(e) {
        e.stopPropagation();

        if (this.props.status === 4) {
            dispatch.lifeCycle.disableLinking();
            dispatch.lifeCycle.setDependencyIcon(false);
        }

        e.target.value = e.target.value.replace(/^0+/, '');
        if (/^((?!(0))[0-9]{1,3})$/.test(e.target.value)) {
            this.props.activityRow.duration = e.target.value;
            this.forceUpdate();
            this.setState({ error: false });
            dispatch.initiatives.updateInitiativeActivityDuration(this.props.activityRow)
        }
        else if (!(e.target.value)) {
            this.props.activityRow.duration = null;
            this.setState({ error: true });
            dispatch.initiatives.updateInitiativeActivityDuration(this.props.activityRow)
        }
        else {
            this.setState({ error: true });
        }
    }
    iconClick = (e) => {
        e.stopPropagation()
        e.preventDefault()
    }
    unlink = (e, activity) => {
        this.props.removeDependency(activity)
        e.stopPropagation()
        e.preventDefault()
    }
    stopProp = (e) => {
        e.stopPropagation()
    }
    keyPress(e) {
        e.stopPropagation();
        if (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 27) {
            e.target.value = e.target.value.replace(/^0+/, '');
            if (e.target.name === 'duration') {
                if (/^((?!(0))[0-9]{1,3})$/.test(e.target.value)) {
                    e.target.value = e.target.value.replace(/^0+/, '')
                    this.props.activityRow.duration = e.target.value;
                    this.forceUpdate();
                    this.setState({ error: false });
                    dispatch.initiatives.updateInitiativeActivityDuration(this.props.activityRow)
                }
                else if (!(e.target.value)) {
                    this.props.activityRow.duration = null;
                    this.setState({ error: true });
                    dispatch.initiatives.updateInitiativeActivityDuration(this.props.activityRow)
                }
                else {
                    this.props.activityRow.duration = null;
                    this.setState({ error: true });
                    dispatch.initiatives.updateInitiativeActivityDuration(this.props.activityRow)
                }

            }
        }
    }

    render() {


        const thisObject = this;
        let run = { name: "", icon: "", class: "" }
        if (this.props.activityRow.runStatus == -1) {
            run = { name: "Not Started", icon: "clock", class: "clr-gray" }
        }
        if (this.props.activityRow.runStatus === 0) {
            run = { name: "Not Started", icon: "clock", class: "clr-gray" }
        }
        if (this.props.activityRow.runStatus === 1) {
            run = { name: "In Progress", icon: "clock", class: "clr-green" }
        }
        if (this.props.activityRow.runStatus === 2) {
            run = { name: "Completed", icon: "check circle outline", class: "clr-blue", image: true }
        }

        let RunStatusIcon = <Popup
            content={run.name}
            className="popupStyled"
            mouseEnterDelay={500}
            inverted
            trigger={run.image ? <Image style={{ marginRight: "8px", float: "right", width: "11px" }} src={completeActivity} /> : <Icon style={{ marginRight: "7px" }} className={run.class} name={run.icon} />} />

        let Delayed = <Popup
            content="Delayed"
            className="popupStyled"
            mouseEnterDelay={500}
            inverted
            trigger={<Icon style={{ marginRight: "7px" }} name="stopwatch" className="clr-orange" />} />

        let IssueIcon = <Popup
            content="Issue"
            className="popupStyled"
            mouseEnterDelay={500}
            inverted
            trigger={<Icon style={{ marginRight: "7px" }} name="warning sign" className="clr-red f_11" />} />

        let OnHoldIcon = <Popup
            content="On Hold"
            className="popupStyled"
            mouseEnterDelay={500}
            inverted
            trigger={<Icon style={{ marginRight: "7px" }} name="pause circle" className="clr-dark-gray" />} />

        let DependencyIcon = <span style={{ 'paddingRight': "2px" }} onClick={(e) => this.unlink(e, this.props.activityRow)}>{this.props.dependIcon}</span>

        let MilestoneIcon = <Popup
            trigger={<span ><img className='pull-left' onClick={this.iconClick} style={{ 'height': '12px', 'paddingRight': '7px', 'marginTop': '1px' }} src={diamond} name="diamond" alt="milestone" /></span>}
            header="Milestone activity"
            inverted
            className="popupStyled"
        />

        let setWidth = 97

        this.props.activityRow.isMilestone ? setWidth = setWidth - 8 : setWidth + 0
        this.props.dependIcon ? setWidth = setWidth - 8 : setWidth + 0
        this.props.status === 4 && this.props.activityRow.isLeafNode && this.props.activityRow.onHoldFlag ? setWidth = setWidth - 8 : setWidth + 0
        this.props.status === 4 && this.props.activityRow.isLeafNode && this.props.activityRow.issueFlag ? setWidth = setWidth - 8 : setWidth + 0
        this.props.status === 4 && this.props.activityRow.isLeafNode && this.props.activityRow.runStatus !== 2 && this.props.activityRow.isDelayedToEnd ? setWidth = setWidth - 8 : setWidth + 0
        this.props.status === 4 && this.props.activityRow.isLeafNode && run.name ? setWidth = setWidth - 8 : setWidth + 0



        if (this.props.status !== 0 && this.props.status !== 4) {
            const Element = this.props.element || this.props.staticElement;
            return <Element
                className={this.props.className}
                style={this.props.style} >
                <EllipsisTooltip name={this.state.text || this.props.placeholder} />
                <div className="durationSelect" > Select box</div>
            </Element >;
        } else {

            if (this.props.isDisabled) {
                const Element = this.props.element || this.props.staticElement;
                return <Element
                    className={this.props.className}
                    style={this.props.style} >
                    <EllipsisTooltip
                        name={this.state.text || this.props.placeholder}
                    />

                </Element >;
            } else if (!this.props.editing) {


                const Element = this.props.element || this.props.staticElement;
                return <Element
                    className={this.props.className}
                    // onDoubleClick={this.doubleClickOnActivity}
                    tabIndex={this.props.tabIndex}
                    style={this.props.style} >
                    <EllipsisTooltip
                        name={this.state.text || this.props.placeholder}
                        style={{
                            width: setWidth + "%", textOverflow: "ellipsis",
                            /* overflow: hidden; */
                            display: "block"
                        }}
                    />
                    <div className="setRightBox" style={{ padding: this.props.status === 4 ? "0 0px 0 10px" : "0 0px " }} >
                        {this.props.activityRow.isMilestone ? MilestoneIcon : null}
                        {this.props.dependIcon ? DependencyIcon : null}
                        {this.props.status === 4 && this.props.activityRow.isLeafNode && this.props.activityRow.onHoldFlag ? OnHoldIcon : null}
                        {this.props.status === 4 && this.props.activityRow.isLeafNode && this.props.activityRow.issueFlag ? IssueIcon : null}
                        {this.props.status === 4 && this.props.activityRow.isLeafNode && this.props.activityRow.runStatus !== 2 && this.props.activityRow.isDelayedToEnd ? Delayed : null}
                        {this.props.status === 4 && this.props.activityRow.isLeafNode && run.name ? RunStatusIcon : null}
                    </div>
                    {(!this.props.hasActivities && !this.props.activityRow.isParentNode) ?
                        <div className="durationSelect"
                            onDoubleClick={this.stopProp}
                            onClick={this.stopProp}>
                            <input
                                type='text'
                                className={((!this.props.activityRow.duration || this.props.activityRow.duration === 0) && !this.props.activityRow.isMilestone) ? 'durationInput has-error' : 'durationInput'}
                                name="duration"
                                label="Duration (In Days)"
                                id={`duration_${this.props.activityRow._id}`}
                                onClick={this.iconClick}
                                value={this.props.activityRow.duration ? this.props.activityRow.duration : 0}
                                onChange={(e) => { thisObject.updateActivityData(e); }}
                                onBlur={(e) => { thisObject.updateActivityData(e); }}
                                onKeyDown={(e) => { thisObject.keyPress(e); }}
                                autoComplete='off'
                                maxLength={3}
                                min="1"
                                max="999"
                                pattern="[0-9]*"
                                disabled={this.props.status === 4 && this.props.activityRow && this.props.activityRow.runStatus === 2}

                            /> <span className='durationDayFont' onClick={this.iconClick}> {this.props.activityRow.duration > 1 ? "Days" : "Day"} </span>
                        </div>
                        : ''}
                </Element >;
            } else {
                const Element = this.props.element || this.props.editingElement;
                return <span><Element

                    onKeyDown={this.keyDown}
                    onBlur={this.finishEditing}
                    className={this.props.activeClassName}
                    placeholder={this.props.placeholder}
                    defaultValue={this.state.text}
                    onChange={this.textChanged}
                    style={this.props.style}
                    ref="input"
                    style={{ 'padding': '5px', width: '100%' }}
                >
                </Element>
                </span>;
            }
        }

    }
}